"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryToolbarButtons = void 0;
var QuoteSummaryWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSummary/QuoteSummaryWidget");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var react_1 = __importDefault(require("react"));
var QuoteSummary = function (props) {
    var quoteDataStore = (0, inversify_react_1.useInjection)("quoteDataStore");
    var projectStore = (0, inversify_react_1.useInjection)("projectStore");
    return (react_1.default.createElement(QuoteSummaryWidget_1.QuoteSummaryWidget, __assign({}, props, { allowErrorMessaging: true, quoteDataStore: quoteDataStore, currencyLocaleProvider: projectStore, settings: props.element.data })));
};
exports.default = QuoteSummary;
var QuoteSummaryToolbarButtons = function (_a) {
    var element = _a.element;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var dispatch = function (key, value) {
        var _a;
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
            action: "update",
            path: widgetManager.getPath(element),
            type: element.type,
            data: (_a = {},
                _a[key] = value,
                _a),
        }));
    };
    return (react_1.default.createElement(kaleidoscope_1.Popover, { padding: "none", theme: kaleidoscope_1.PopoverTheme.Dark, autoStack: true, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({ icon: react_1.default.createElement(icons_1.Edit, null) }, buttonProps)); }, offset: 8 },
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l", paddingTop: "l", paddingBottom: "m" },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", theme: "dark" }, "Quote summary options"),
            react_1.default.createElement(kaleidoscope_1.Stack, { paddingBottom: "s", paddingTop: "s" },
                react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_1.ToggleTheme.Dark, label: "Compact section headers", value: element.data.compactSectionHeaders, onChange: function (value) { return dispatch("compactSectionHeaders", value); } }),
                react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs", theme: "dark" }, "Show only the first line of section headers")),
            react_1.default.createElement(kaleidoscope_1.Stack, { paddingBottom: "s" },
                react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_1.ToggleTheme.Dark, label: "Compact line item descriptions", value: element.data.compactLineItemDescriptions, onChange: function (value) { return dispatch("compactLineItemDescriptions", value); } }),
                react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs", theme: "dark" }, "Show only the first line of item descriptions")),
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_1.ToggleTheme.Dark, label: "Show plan section headers", value: element.data.showPlanSectionHeaders, onChange: function (value) { return dispatch("showPlanSectionHeaders", value); } }),
                react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_1.ToggleTheme.Dark, label: "Show feature lists", value: element.data.showFeatureLists, onChange: function (value) { return dispatch("showFeatureLists", value); } }),
                react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_1.ToggleTheme.Dark, label: "Show text line items", value: element.data.showTextItems, onChange: function (value) { return dispatch("showTextItems", value); } })))));
};
exports.QuoteSummaryToolbarButtons = QuoteSummaryToolbarButtons;
